module.exports = __webpack_public_path__ + "img/section4_pic1@2x.fe525886.png";